import React from 'react';
import { makeStyles, mergeClasses } from '@fluentui/react-components';
import { FolderIcon } from '../folder-icon-component';

import { getFolderProgressPreviewStyles } from './styles';

const useStyle = makeStyles(getFolderProgressPreviewStyles);

export const createFolderPreviewComponent = ({ i18n }) => ({
  url,
  alt,
  name,
  numberOfAssets,
}) => {
  const classes = useStyle();
  return (
    <div className={mergeClasses('folder-upload-image-content', classes.imageContent)} alt={alt}>
      <FolderIcon thumbnailImageUrl={url} folderIconRootClassName={classes.folderIconRoot} />
      <div className={classes.imageContentText}>
        <div className={mergeClasses('folder-name', classes.folderName)}>
          {name}
        </div>
        <div className={classes.folderSize}>
          {i18n.getString(_TL_('{{numberOfAssets}} assets'), { numberOfAssets: numberOfAssets || 0 })}
        </div>
      </div>
    </div>
  );
};
